<template>
    <div class="card-container" v-if="!$country.is_india">
        <div class="img-container">
            <img src="/assets/valentines/fourty_percent.svg" alt="discount svg" width="121" height="69" >
        </div>
        <div class="content-container">
            <!-- <h5 class="mb-2 font-active">Black Friday Sale</h5> -->
            <!-- <h5 class="mb-2 font-active">Christmas Sale</h5> -->
            <!-- <h5 class="mb-2"></h5> -->
            <p class="code">
                <span>She Chose You! </span>
                <br><span class="discount">
                Choose the perfect engagement ring for her!
            </span>
            </p>
            <!-- <ValentinesGetCode title="Get code"/> -->
            <!-- <p  @click="openValentine" class="get_code">get code</p> -->
            <!-- <p  class="code">Sign up now to get an exclusive discount code!</p> -->
        </div>
        <p class="terms-and-condition" @click="openTandcModal">
            <span >*T&C APPLIED</span>
        </p>

        <CommonCustomModal v-model="tandcModal" :size="'sm'" :no_padd="false">
			<ModalTermsAndConditionsBF />
        </CommonCustomModal>

        <!-- <CommonCustomModal v-model="valentine" :size="'lg'" :no_paddVal="true">
            <ValentinesSubscribeModal @hideModal="hideModal" />
        </CommonCustomModal>     -->

    </div>
</template>

<script setup>
    const { $country} = useNuxtApp()
    const route = useRoute();
   
    const tandcModal = ref(false);
    const valentine = ref(false);

    const openTandcModal =()=>{
        tandcModal.value = true;
    }

    const openValentine =()=>{
        valentine.value = true;
    }

    const hideModal = () => {
         valentine.value = false;
    };
</script>

<style scoped>
    .card-container{
        position: relative;
        padding: 12px 24px;
        display: flex;
        align-items: center;
        /* gap:30px; */
        border-radius: 8px;
        /* background: #a41e36; */
        background: #26332D;
        overflow:hidden;
    }


    .code{
        font-weight: 500;
        font-size: 18px;
        letter-spacing: 2.5px;
        color: #ffff;
        text-transform: uppercase;
    }
    .discount{
        font-weight: 400;
        font-size: 18px;
        letter-spacing: 0;
        color: #D1BEAD;
        text-transform: none;
    }
    .key{
        font-weight: 600;
    }
    p{
        margin: 0;
        color: #eaeaea;   
        /* font-size: 14px */
    }

    .img-container{
        border-radius: 4px;
        max-width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    img{
        max-width: 100%;
        height: auto;
    }

    .code span{
        /* font-weight: bold; */
        /* color:#fff; */
        /* text-decoration: underline; */
    }
    
    .content-container{
        /* padding-left: 4% 20px 0px 20px; */
        padding: 12px;
        padding-left: 4%;
    }

    .terms-and-condition{
        position: absolute;
        color: #c4c4c4;
        letter-spacing: 1px;
        font-size: 10px;
        bottom: 10px;
        right: 10px;
        text-transform: uppercase;
        margin: 0;
        cursor: pointer;
    }

    .get_code{
        cursor: pointer;
        text-decoration:underline;
        color: #fff;
        text-transform: uppercase;
        font-size:14px;
        letter-spacing: 1.5px;
    }
    
    /* .content-container br{
        display: none;
    } */

    @media (max-width : 1150px){
        .code{
            font-size: 16px;
        }
    }

    @media(max-width:992px){
        .discount{
            font-size: 14px;
        }
    }
    @media(max-width:767px){
        .card-container{
            padding: 12px 16px;
        }
        .content-container br{
            display: block;
        }
        .img-container{
            max-width: 80px;
        }
        .code, .discount{
            font-size: 14px;
            /* margin-top: 6px; */
        }
        .code{
            letter-spacing: 1.5px;
        }
        .terms-and-condition{

            top: 10px;
            right: 10px;
    }

        p{
            font-size: 12px;
        }
    }

    /* @media(max-width:991px){
        .card-container{
            padding: 25px 10px;
        }

    } */

</style>